import React, { useState, useRef, useEffect } from "react";

const DropdownButtonMenu = ({ children }) => {
	const [open, setOpen] = useState(false);
	const node = useRef();

	//https://codesandbox.io/s/9o3lw5792w
	const handleClickOutside = e => {
		//@ts-ignore
		if (node.current.contains(e.target)) {
			// inside click
			return;
		}
		setOpen(false);
	};

	useEffect(() => {
		//@ts-ignore
		if (open !== null) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [open]);

	return (
		<div className="dropdown" ref={node}>
			<div className="dropdownButton" onClick={() => setOpen(!open)} />
			{open ? <div className="dropdownMenu">{children}</div> : null}
		</div>
	);
};

export default DropdownButtonMenu;
